import * as Yup from 'common/yup';
import {enumType} from '../common/enumType';
import {diplomatObjectSchema, DiplomatObjectNames} from './diplomat-object';
import {TransactionType} from './TransactionType';
import {getTransportSchemaByType} from './transport/Transport';
import {Transport, transportTypeSchema} from 'types/transport/Abstract/AbstractTransport';
import {TransportType} from './TransportType';
import {DiplomatObjectType} from 'types/DiplomatObjectType';

export const PartnerNames = {
   transport: 'transport',
} as const;

export interface Partners {
   trustedPartners: IPartner[];
   publicPartners: IPartner[];
}

export const KeySet = Yup.object({
   encryptionKeyId: Yup.idString().nullable(),
   signatureKeyId: Yup.idString().nullable(),
});
export type IKeyset = Yup.InferType<typeof KeySet>;

export const PartnerType = enumType({
   EXTERNAL: 'Public',
   INTERNAL: 'Trusted',
});

export const Partner = diplomatObjectSchema.shape({
   name: Yup.string(), //.required(i18n.t('Please enter the name of the partner')),
   anonymous: Yup.boolean(),
   description: Yup.string(),
   type: Yup.string().oneOf(PartnerType.keys).default(PartnerType.enum.INTERNAL),
   [DiplomatObjectNames.objectType]: Yup.string()
      .oneOf(DiplomatObjectType.keys)
      .default(DiplomatObjectType.enum.INTERNAL_PARTNER),
   [PartnerNames.transport]: Yup.lazy((transport: Transport) =>
      getTransportSchemaByType(transport?.transportType)
   ),
   keySet: KeySet,
});

export type IPartner = Yup.InferType<typeof Partner>;

export const SourcePartner = Partner.shape({
   transport: Yup.lazy((transport: Transport) =>
      getTransportSchemaByType(transport?.transportType).shape({
         transportType: transportTypeSchema.test(
            'AS2 Partner Error',
            'You may not choose an AS2 partner as the Source of a Transaction.\nAS2 is a Destination-only protocol.',
            (transportType: string) => transportType !== TransportType.enum.AS2
         ),
      })
   ),
});

export const makeAnonymousPartner = (partner: IPartner, transactionType: string) => {
   const newPartner = Partner.cast(partner);
   newPartner.id = '';
   newPartner.anonymous = true;
   if (transactionType === TransactionType.enum.INBOUND) {
      if (partner.type === PartnerType.enum.EXTERNAL) {
         //source - remove encryption key
         newPartner.keySet.encryptionKeyId = '';
      } //internal
      else {
         //destination - remove signature key
         newPartner.keySet.signatureKeyId = '';
      }
   } else {
      //outbound
      if (partner.type === PartnerType.enum.EXTERNAL) {
         //destination - remove signature key
         newPartner.keySet.signatureKeyId = '';
      } else {
         //internal

         //source - remove encryption key
         newPartner.keySet.encryptionKeyId = '';
      }
   }
   return newPartner;
};
